import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";
import { getRequest } from '../../../../api/ApiService';
import Teams from '../../../../api/Teams';
import Auth from '../../../../routes/Auth';
import { Loader } from 'react-loaders';

import Image from '../../../../containers/assets/pf1.png';

class ResultsAreInStep3 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      rank: null,
      loaded: false,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const gameId = Number(Auth.getGameId());
    const team = Teams.currentTeam();
    const teamId = Number(team.id);
    const roundNumber = Number(activeRound);
    const round = rounds.find(i => Number(i.number) === roundNumber);
    const roundId = round ? Number(round.id) : 0;

    getRequest(`${process.env.REACT_APP_API_URL}v2/games/teamgradings/?round=${roundId}&game=${gameId}&team=${teamId}`)
      .then(res => {
        let rank = null;
        if (res.body && res.body.results) {
          const data = res.body.results.find(i => (
            Number(i.game) === gameId
            && Number(i.round_number) === roundNumber
            && Number(i.team) === teamId
          ));

          if (data && data.ranking) {
            rank = data.ranking;
          }
        }

        this.setState({
          rank,
          loaded: true,
        });
      })
      .catch(err => { });
  }

  render() {
    const { loaded } = this.state;

    return loaded ? (
      <OneVisualLayout
        section="RESULTS ARE IN!"
        title="Congratulations!"
        paragraph1={(
          <Fragment>
            Your team hit all of the targets in the past round!
          </Fragment>
        )}
        visual={(
          <img src={Image} alt="preview" />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ResultsAreInStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/results-are-in/step3.js